import React from 'react';
import AppVars from '../../AppVars.js';
import TODealerView from '../Views/TO/Dealer/DealerView';
import navigateWithAnalytics from '../../analytics/navigateWithAnalytics.js';
import pushAnalytics from '../../analytics/pushAnalytics.js';

const appVars = AppVars.getInstance();

const INPUT_TYPES = {
    "PHONE": "^(?!0)[0-9]{10}$",
    "EMAIL": "(^[0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*@([0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*\\.(AERO|ARPA|BIZ|COM|COOP|EDU|GOV|INFO|INT|LAW|MIL|MOBI|MUSEUM|NAME|NET|ORG|PRO|TRAVEL|aero|arpa|biz|com|coop|edu|gov|info|int|law|mil|mobi|museum|name|net|org|pro|travel|[A-Za-z][A-Za-z])|([0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}))(:[0-9]{1,5})?$)"
}

const COMPONENT_TREE = [
    { component_name: 'Dealer', component_version: '1.0.0' }
];

class Dealer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            payload: null,
            code: null,
            username: null,
            signInType: null,
            showForm: "VERIFY",
        };
        this.displayForm = this.displayForm.bind(this);
        this.savePayload = this.savePayload.bind(this);
        this.saveCode = this.saveCode.bind(this);
    }

    componentDidMount() {
        if (!sessionStorage.AP_SSID) {
            navigateWithAnalytics("/", "default-redirect", "auto");
        }

        const payloadStr = sessionStorage.getItem("AP_PAYLOAD");
        if (payloadStr) {
            try {
                const payload = JSON.parse(payloadStr);
                sessionStorage.removeItem("AP_PAYLOAD");
                this.setState({ payload });
            } catch (error) {
                console.error("Invalid payload format", error);
                sessionStorage.removeItem("AP_PAYLOAD");
            }
        }
    }

    checkUsernameType(username) {
        let TYPE = null;
        for (const key in INPUT_TYPES) {
            if (username.match(INPUT_TYPES[key]) && appVars.getIncludeSignIn(key)) {
                TYPE = key;
            }
        }
        return TYPE;
    }

    saveCode(value) {
        this.setState({ code: value })
    }

    savePayload(value) {
        this.setState({ payload: value });
    }

    displayForm(value) {
        if (this.state.showForm !== value) {
            pushAnalytics('aa-view-change', { from_view: this.state.showForm, to_view: value, context: 'dealer-flow' }, COMPONENT_TREE);
        }
        this.setState({ showForm: value });
    }

    render() {
        return (
            <TODealerView
                style={sessionStorage.AP_STYLE}
                showForm={this.state.showForm}
                signInType={this.checkUsernameType(sessionStorage.AP_SSID)}
                payload={this.state.payload}
                code={this.state.code}
                savePayload={this.savePayload}
                saveCode={this.saveCode}
                displayForm={this.displayForm}
            />
        )
    }
}

export default Dealer;